<template>
  <StandardCardPageContainer>
    <LoadingCircle v-if="isLoading"></LoadingCircle>
    <div v-else>
      <h1>Admin Users</h1>
      <v-table>
        <thead>
          <tr>
            <th class="text-left">Email</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" class="text-left">
            <td>{{ user.email }}</td>
          </tr>
        </tbody>
      </v-table>
      <v-row justify="start">
        <PSecondaryButton
          class="ml-3 mt-8"
          @click="$router.push(RouterPath.AdministratorPage)"
          >Back</PSecondaryButton
        >
      </v-row>
    </div>
  </StandardCardPageContainer>
</template>

<script setup lang="ts">
import StandardCardPageContainer from "@/components/containers/StandardCardPageContainer.vue";
import type { UserProfile } from "@/models/userProfile";
import { onMounted, ref } from "vue";
import { getAdminUserProfiles } from "@/services/userProfilesService";
import PSecondaryButton from "@/components/custom/buttons/PSecondaryButton.vue";
import { RouterPath } from "@/models/enum/routerPath";
import LoadingCircle from "@/components/custom/LoadingCircle.vue";

const isLoading = ref(true);
const users = ref(new Array<UserProfile>());

onMounted(async () => {
  isLoading.value = true;
  await getUsers();
  isLoading.value = false;
});

async function getUsers() {
  users.value = await getAdminUserProfiles();
}
</script>
